<template>
  <div>
    <div class="d-flex flex-row flex-wrap justify-space-between"></div>
    <v-expand-transition>
      <div v-if="showMore" class="my-1">
        <div v-if="mainTag && rgpOptions.tagGroups[mainTag]" class="my-2">
          <div class="overline">
            {{ rgpOptions.tags[mainTag].name }} Options
          </div>
          <v-divider class="mb-2"></v-divider>

          <rgp-tag-selector-group
            :tags="rgpOptions.tags"
            :tagGroups="rgpOptions.tagGroups[mainTag]"
            :activeTags="activeTags"
            :allowedTags="allowedTags"
            :universalTags="universalTags"
            :parentIds="[mainTag]"
            :displayOnly="displayOnly"
            :displayRow="true"
            @tagClicked="tagClicked($event)"
          >
            <!--  :tags="rgpOptions.tags"-->
          </rgp-tag-selector-group>

          <div class="overline mt-2" v-if="tagGroupsWithoutMain">
            Other Options
          </div>
          <v-divider class="" v-if="tagGroupsWithoutMain"></v-divider>
        </div>
        <rgp-tag-selector-group
          :tags="rgpOptions.tags"
          :tagGroups="tagGroupsWithoutMain"
          :activeTags="activeTags"
          :allowedTags="allowedTags"
          :universalTags="universalTags"
          :displayOnly="displayOnly"
          @tagClicked="tagClicked($event)"
        >
          <!--  :tags="rgpOptions.tags"-->
        </rgp-tag-selector-group>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
// import Name from "../dir/file";
import RgpTagSelectorGroup from "./RgpTagSelectorGroup";
import RgpOptionsMixin from "@/assets/js/rgps/RgpOptionsMixin.js";

// import RgpTagSelectorSelect from "./RgpTagSelectorSelect";

export default {
  name: "RgpTagSelector",
  props: {
    rgpOptions: null, // [tags:{}, tagGroups:{}]
    // tags: null,
    // tagGroups: null,
    allowedTags: null,
    universalTags: null, // tags that all items include (we will not supply a checkbox for these since unchecking it will result in no items)
    mainTag: null, // for example, if the search was for "presbyopia", this would be the presbyopia tag id. This will show
    displayOnly: null, // if true will not display checkboxes, will be displayed as a "label", and will have fancy colors. Clicking it will navigate to a search for that tag
    showMore: { type: Boolean, default: true },
    activeTags: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    RgpTagSelectorGroup,
    // RgpTagSelectorSelect,
  },
  mixins: [RgpOptionsMixin],
  data: function () {
    return {
      localTags: [],
    };
  },
  methods: {
    tagClicked(id) {
      console.log(id);
      let isActive = this.localTags.includes(id);

      if (!isActive) {
        this.localTags = this.addChildTagAndParents(this.localTags, id); // (from mixin) add a tag to the list and make sure its parents are selected too
        // this.localTags.push(String(id));
        // this.selectParentTags(id); // if a tag is selected, make sure its parents are selected too
      } else {
        this.localTags = this.removeTagAndChildren(this.localTags, id); // from mixin, remove a tag from the list and make sure its descendants are removed too
        //this.localTags = this.localTags.filter((e) => e !== id);
        // this.uncheckId(id);
        // this.unselectChildTags(id); // if a tag is deselected, make sure its children are too
      }
      this.$emit("tags", this.localTags);
      // this.doEmit();
    },
    // selectParentTags(childId) {
    //   // console.log(childId);
    //   let childObj = this.tags[childId];

    //   let parentId = childObj.parentId;
    //   if (!parentId) return;
    //   let parentActive = this.localTags.includes(parentId);
    //   if (!parentActive) this.localTags.push(String(parentId));
    //   // now see if the parent's parent is active..
    //   this.selectParentTags(parentId);
    // },
    // unselectChildTags(parentId) {
    //   let kidIds = this.kidsWithParentId(parentId);
    //   let that = this;
    //   kidIds.forEach((id) => {
    //     that.uncheckId(id);
    //     that.unselectChildTags(id);
    //   });
    // },
    // kidsWithParentId(id) {
    //   let rtn = [];
    //   let allTags = this.tags;
    //   let allTagIds = Object.keys(allTags);
    //   allTagIds.forEach((tId) => {
    //     const obj = allTags[tId];
    //     if (obj.parentId == id) rtn.push(tId);
    //   });
    //   return rtn;
    // },

    // uncheckId(id) {
    //   this.localTags = this.localTags.filter((e) => e !== id);
    // },
  },
  computed: {
    tagGroupsWithoutMain: function () {
      if (!this.mainTag) return this.rgpOptions.tagGroups;
      let copy = { ...this.rgpOptions.tagGroups };
      delete copy[this.mainTag];
      return copy;
    },
    // tagGroupsToInclude: function () {
    //   let groupsObj = this.tagGroups;
    //   return groupsObj;
    //   // let t2i = this.allowedTags;
    //   // if (!t2i) return groupsObj;
    //   // let filtered = {};
    //   // t2i.forEach((tagId) => {
    //   //   if (groupsObj[tagId]) {
    //   //     let groupChildIdArr = Object.keys(groupsObj[tagId]);
    //   //     let childObjsToKeep = {};
    //   //     groupChildIdArr.forEach((id) => {
    //   //       if (t2i.includes(id)) childObjsToKeep[id] = groupsObj[tagId][id];
    //   //     });
    //   //     filtered[tagId] = childObjsToKeep;
    //   //   }
    //   // });
    //   // return filtered;
    // },
  },
  watch: {
    activeTags: {
      handler: function (val) {
        this.localTags = val;
      },
      deep: true,
    },
  },
  mounted() {
    this.localTags = this.activeTags;
    // if (this.displayOnly) this.showMore = true;
  },
};
</script>

<style scoped></style>
